import { useEffect, useState } from 'react';
import { Box, Container, Alert, CircularProgress, Typography } from '@mui/material';
import { useGetNotificationSettingsQuery } from './api/notificationsApi';
import {
  getGeneratedNotificationGridKey,
  NOTIFICATIONS_UPDATED_EVENT,
} from './notificationGeneratedGrid';
import { GridPage } from '../grid/GridPage';

export function NotificationGeneratedGridPage() {
  const { data, isLoading, isError } = useGetNotificationSettingsQuery();
  const gridKey = getGeneratedNotificationGridKey(data);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const handleNotificationsUpdated = () => {
      setRefreshKey((value) => value + 1);
    };
    window.addEventListener(NOTIFICATIONS_UPDATED_EVENT, handleNotificationsUpdated);
    return () => {
      window.removeEventListener(NOTIFICATIONS_UPDATED_EVENT, handleNotificationsUpdated);
    };
  }, []);

  if (isLoading) {
    return (
      <Container maxWidth={false} sx={{ mt: 1 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (isError || !gridKey) {
    return (
      <Container maxWidth={false} sx={{ mt: 1, maxWidth: '1400px' }}>
        <Alert severity="error">
          <Typography variant="body2">Could not resolve the notifications grid.</Typography>
        </Alert>
      </Container>
    );
  }

  return (
    <GridPage
      key={`${gridKey}-${refreshKey}`}
      standaloneNodeKey={gridKey}
      standaloneTitle="Notifications"
    />
  );
}
